import { CSS, Flex } from '@project44/manifest-ds';

interface TablePaperProps {
  children: React.ReactNode;
  css?: CSS;
}

function TablePaper({ children, css }: TablePaperProps) {
  return (
    <Flex
      orientation="vertical"
      css={{
        backgroundColor: '$palette-grey-50',
        borderRadius: '$small',
        boxShadow: '$medium',
        height: '100%',
        padding: '$medium',
        ...css,
      }}
    >
      {children}
    </Flex>
  );
}

export default TablePaper;
